import { StructureRow } from "./types/wall";

export enum Joint {
  Vertical,
  Horizontal,
}

export enum JointSize {
  Glued = 3,
  Small = 6,
  Large = 12,
}

export enum StructureType {
  HalfBrick = "Half",
  Wild = "Wild",
  Stack = "Stack",
  Cross = "Cross",
  // Baekel,
}

export enum BrickPattern {
  Full = "full",
  Half = "half",
  // Baekel = "baekel",
}

export enum BrickSizes {
M50 = "M50",
  M65 = "M65",
  HF = "HF",
  WF = "WF",
  DL = "DL",
  DF40 = "DF 40",
  DF52 = "DF 52",
  LF36540 = "LF 365/40",
  LF36552 = "LF 365/52",
  LF490 = "LF 490"
}

export interface JointClass {
  name: string;
  img: string;
}

export interface Structure {
  name: string;
  rows: StructureRow[];
}

export const brickSizes: Record<
  BrickSizes,
  { width: number; height: number }
> = {
  [BrickSizes.M50]: {
    width: 190,
    height: 50,
  },
  [BrickSizes.M65]: {
    width: 190,
    height: 65,
  },
  [BrickSizes.HF]: {
    width: 240,
    height: 40,
  },
  [BrickSizes.WF]: {
    width: 210,
    height: 50,
  },
  [BrickSizes.DL]: {
    width: 290,
    height: 50,
  },
  [BrickSizes.DF40]: {
    width: 240,
    height: 40,
  },
  [BrickSizes.DF52]: {
    width: 240,
    height: 52,
  },
  [BrickSizes.LF36540]: {
    width: 365,
    height: 40,
  },
  [BrickSizes.LF36552]: {
    width: 365,
    height: 52,
  },
  [BrickSizes.LF490]: {
    width: 490,
    height: 40,
  }
};

export const structures: Record<StructureType, Structure> = {
  [StructureType.HalfBrick]: {
    name: "Halfsteens",
    rows: [
      { pattern: [BrickPattern.Full], margin: -0.5 },
      { pattern: [BrickPattern.Full], margin: 0 },
    ],
  },
  [StructureType.Wild]: {
    name: "Wild",
    rows: [
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
    ],
  },
  [StructureType.Stack]: {
    name: "Gestapeld",
    rows: [{ pattern: [BrickPattern.Full], margin: -0.5 }],
  },
  [StructureType.Cross]: {
    name: "Kruis",
    rows: [
      { pattern: [BrickPattern.Full], margin: -0.5 },
      { pattern: [BrickPattern.Half], margin: -0.5 },
      { pattern: [BrickPattern.Full], margin: 0 },
      { pattern: [BrickPattern.Half], margin: -0.5 },
    ],
  },
  // [StructureType.Baekel]: {
  //   name: "Test",
  //   rows: [
  //     { pattern: [BrickPattern.Full], margin: -0.5 },
  //     { pattern: [BrickPattern.Baekel], margin: -0.25 },
  //     { pattern: [BrickPattern.Full], margin: 0 },
  //     { pattern: [BrickPattern.Baekel], margin: -0.25 },
  //   ],
  // },
};

const jointImages = import.meta.glob<string>("./joints/*.jpg", {
  eager: true,
  query: "?url",
  import: "default",
});

export const JOINTS: JointClass[] = Object.entries(jointImages)
  .map(([path, img]) => ({
    name: path.replace(/^.*\/(.*)\.jpg$/, "$1"),
    img,
  }))
  .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));

// Physical edge length of every joint texture image. Tuned by eye; the source images are 400 px.
export const JOINT_TEXTURE_SIZE_MM = 150;
